<template>
    <div class="bcgl">
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">过期装备</div>
                        </el-col>

                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData()">

                            <el-form-item>
                                <el-input placeholder="请输入姓名" @change="changeIndex" v-model="searchForm.xm"
                                          clearable></el-input>
                            </el-form-item>
                            <!--		<el-form-item  >
                                        <el-select  @change="getConfigDetail" v-model="searchForm.configId" filterable clearable placeholder="请选择装备配置">
                                            <el-option

                                                    v-for="item in equipConfigs"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item  >
                                    <el-select  @change="changeIndex" v-model="searchForm.typeId" filterable clearable placeholder="请选择装备">
                                        <el-option

                                                v-for="item in types"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                    </el-form-item>-->
                            <el-form-item>
                                <el-select @change="changeIndex" clearable :disabled="deptdisable" filterable
                                           v-model="searchForm.bmid" placeholder="请选择部门">
                                    <el-option
                                            v-for="item in depts"
                                            :key="item.bmid"
                                            :label="item.bmmc"
                                            :value="item.bmid"
                                            :disabled="deptdisable">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-input @change="changeIndex" placeholder="请输入岗位" v-model="searchForm.gw"
                                          clearable></el-input>
                            </el-form-item>
                            <el-form-item label="" prop="startTime">
                                <!--								<el-date-picker-->
                                <!--										@change="changeIndex"-->
                                <!--										v-model="searchForm.startTimeed"-->
                                <!--										type="date"-->
                                <!--										value-format="yyyy-MM-dd"-->
                                <!--										placeholder="过期日期">-->
                                <!--								</el-date-picker>-->

                                <div class="block">
                                    <span class="demonstration">过期日期</span>
                                    <el-date-picker
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            v-model="gqrq"
                                            type="datetimerange"
                                            :picker-options="pickerOptions"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            align="right">
                                    </el-date-picker>
                                </div>
                            </el-form-item>
                            <el-form-item label="年龄">
                                <el-input :size="mini" style="width: 100px;" v-model="searchForm.startAge" ></el-input> - <el-input :size="mini" style="width: 100px;" v-model="searchForm.endAge" ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="searchData()">查询</el-button>
                                <!--								<el-button v-if="isAuth('equipContract:add')" type="primary" @click="addOrUpdate()"  style="display: inline;">出库</el-button>-->
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :header-cell-class-name="handleHeaderClass"
                        @sort-change="handleTableSort"
                        @selection-change="selectionChangeHandle"
                        :data="contractList" v-loading="loading" :row-key="getRowKeys"
                        style="text-align: center; width: 100%;">


                    <el-table-column prop="recipientName" label="人员">

                    </el-table-column>
                    <el-table-column label="工号" prop="workNumber">
                    </el-table-column>
                    <el-table-column label="年龄">
                        <template slot-scope="scope">
                            {{getAge(scope.row.csrq)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="身份证号码" prop="u.sfzhm" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.sfzhm}}
                        </template>
                    </el-table-column>
                    <el-table-column label="部门" prop="b.bmmc" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.dept}}
                        </template>
                    </el-table-column>

                    <el-table-column label="岗位" prop="u.gw" sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.gw}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" :render-header="renderHeader">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="showInfo(scope.row)">详情</el-button>
                            <el-button type="text" size="mini" v-if="isAuth('equip:out')"
                                       @click="addOrUpdate(scope.row.recipient)">出库
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
            </el-card>
            <el-dialog
                    style="text-align: left"
                    title="导出"
                    :visible.sync="exportVisible"
            >
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
                </el-checkbox>
                <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
                    <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}
                    </el-checkbox>
                </el-checkbox-group>
                <form ref="exportForm" method="post"
                      :action="this.$request.defaults.baseURL+'/bjba/equip/outDeatil/exportExpireExcel?access_token='+this.$store.getters.token"
                      target="_blank">
                    <input type="hidden" v-for="(value,key,index) in searchForm" :name="key" :value="value"/>
                    <input type="hidden" name="fileds" value="" ref="fileds"/>
                </form>
                <span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
            </el-dialog>
        </div>
        <add-or-update v-if="customerVisible" ref="customer" @refreshDataList="searchData"></add-or-update>
        <out-log v-if="showInfoVisible" ref="showInfo"></out-log>

    </div>
</template>
<script>
    import {Component, Vue} from 'vue-property-decorator'
    import AddOrUpdate from './equip-out'
    import OutLog from './detail-out-log3'

    const exportFields = [
        {value: "gw", name: "岗位"},
        {value: "time", name: "发放时间"},
        {value: "expireDate", name: "过期日期"},
        {value: "name", name: "名称"},
        {value: "num", name: "数量"},
        {value: "equipSize", name: "尺寸"},
        {value: "specification", name: "规格"},
        {value: "unit", name: "单位"},
        {value: "price", name: "单价"},
        {value: "useTime", name: "使用年限"},
        {value: "recipientName", name: "使用人"},
        {value: "workNumber", name: "工号"},
        {value: "dept", name: "部门"},
        {value: "sfzhm", name: "身份证号码"}

    ]
    @Component({
        name: 'contractinfo',
        components: {
            AddOrUpdate,
            OutLog
        }
    })
    export default class contractinfo extends Vue {
        customerVisible = false
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        activeNames = [];
        showbmxxVisible = false;
        customerList = []
        showfileVisible = false
        deptdisable = false
        showInfoVisible = false
        types = []
        equipConfigs = []
        searchForm = {
            startTimest: '',
            startTimeed: '',
            startAge:'',
            endAge:'',
            bmid: '',
            configId: '',
            xm: '',
            gw: '',
            typeId: ''
        }
        gqrq=[]
        pickerOptions = {
            shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    debugger
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近一个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                }
            }, {
                text: '最近三个月',
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                }
            }]
        }
        depts = []
        startTime = []
        endTime = []
        amount = ['', '']
        contractList = []
        loading = false;
        dataListSelections = [];
        sjbm = []
        selectBm = ''
        orders = []
        isIndeterminate = false
        exportVisible = false
        checkAll = false
        fields = exportFields
        filedValues = exportFields.map(item => item.value)
        fieldList = []

        created() {
            this.getTypes()
            this.getEquipConfigs()
            this.searchData();
            this.getDepts()
        }

        handleSizeChange(val) {
            this.pageSize = val;
            this.searchData();
        }

        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }

        getAge(strBirthday) {
            var birArr = strBirthday.split("-");
            var birYear = birArr[0];
            var birMonth = birArr[1];
            var birDay = birArr[2];

            d = new Date();
            var nowYear = d.getFullYear();
            var nowMonth = d.getMonth() + 1; //记得加1
            var nowDay = d.getDate();
            var returnAge;

            if (birArr == null) {
                return false
            };
            var d = new Date(birYear, birMonth - 1, birDay);
            if (d.getFullYear() == birYear && (d.getMonth() + 1) == birMonth && d.getDate() == birDay) {
                if (nowYear == birYear) {
                    returnAge = 0; //
                } else {
                    var ageDiff = nowYear - birYear; //
                    if (ageDiff > 0) {
                        if (nowMonth == birMonth) {
                            var dayDiff = nowDay - birDay; //
                            if (dayDiff < 0) {
                                returnAge = ageDiff - 1;
                            } else {
                                returnAge = ageDiff;
                            }
                        } else {
                            var monthDiff = nowMonth - birMonth; //
                            if (monthDiff < 0) {
                                returnAge = ageDiff - 1;
                            } else {
                                returnAge = ageDiff;
                            }
                        }
                    } else {
                        return  "出生日期晚于今天，数据有误"; //返回-1 表示出生日期输入错误 晚于今天
                    }
                }
                return returnAge;
            } else {
                return ("输入的日期格式错误！");
            }
        }

        changeIndex() {
            this.currentNo = 1
        }

        preview(row) {
            // var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview/'+id+'?type=1&access_token='+this.$store.getters.token
            // window.open(viewUrl)
            this.showfileVisible = true
            this.$nextTick(() => {
                this.$refs.showfile.init(row)
            })
        }

        getConfigDetail() {
            this.changeIndex()
            this.searchForm.typeId = ''
            this.types = []
            if (this.searchForm.configId) {
                this.$http({
                    url: '/bjba/equip/config/details/' + this.searchForm.configId,
                    method: 'get'
                }).then(({data}) => {
                    this.types = data.data
                })
            } else {
                this.getTypes()
            }
        }

        getRowKeys(row) {
            return row.id;
        }

        showInfo(row) {
            this.showInfoVisible = true
            let param = {recipient: row.recipient, startTimest: this.searchForm.startTimest, startTimeed: this.searchForm.startTimeed}
            this.$nextTick(() => {
                this.$refs.showInfo.init(param)
                // this.$refs.showInfo.init(row)
            })
        }

        getParams() {

            this.searchForm.page = this.currentNo
            this.searchForm.pagesize = this.pageSize
            this.searchForm.orders = encodeURI(JSON.stringify(this.orders))
        }

        searchData() {
            debugger
            // alert(JSON.stringify(this.gqrq))
            if(this.gqrq!=''&&this.gqrq!=null&&this.gqrq.length==2){
                this.searchForm.startTimest = this.gqrq[0]
                this.searchForm.startTimeed = this.gqrq[1]
            }else{
                this.searchForm.startTimest = ''
                this.searchForm.startTimeed = ''
            }
            if (this.searchForm.startAge.length<=0||this.searchForm.endAge.length<=0){
                this.searchForm.startAge=''
                this.searchForm.endAge=''
            }
            this.getParams()
            this.loading = true;
            this.$request({
                url: '/bjba/equip/outDeatil/findExpire',
                method: 'get',
                params: this.searchForm
            })
                .then(response => {
                    this.loading = false;
                    console.log(response);
                    let data = response.data;
                    if (data.code == 200) {
                        this.contractList = data.data.content;
                        this.pageTotal = data.data.totalElements
                    } else {
                        this.$message.error(data.message)
                    }
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error)
                    this.$message.error(error)
                });
        }

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        }

        // 设置列的排序为我们自定义的排序
        handleHeaderClass({column}) {
            if (!column.multiOrder) column.multiOrder = ''
            column.order = column.multiOrder
        }

        handleOrderChange(orderColumn, orderState) {
            let result = this.orders.find(e => e.orderColumn === orderColumn)
            if (result) {
                if (orderState)
                    result.orderState = orderState
                else {
                    var j = this.orders.indexOf(result);
                    if (j !== -1) {
                        this.orders.splice(j, 1);
                    }
                }
            } else {
                this.orders.push({
                    orderColumn: orderColumn,
                    orderState: orderState
                })
            }
            this.searchData()
        }

// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
        handleTableSort({column}) {
            console.log(column.orderfield)
            column.multiOrder = column.order
            this.handleOrderChange(column.property, column.multiOrder)
        }

        handleCheckAllChange(val) {
            this.fieldList = val ? this.filedValues : [];
            this.isIndeterminate = false;
        }

        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.filedValues.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
        }

        showExportDialog() {
            this.exportVisible = true
        }

        renderHeader(h) {
            return ( < div class = "clearfix">
                < span > 操作 < /span>
                < el-button style = "padding:5px;float:right" size = "mini"
            onClick = {()=>
            this.showExportDialog()
        }>
            导出 < /el-button></
            div >
        )
        }

        exportExcel() {
            var filedLast = this.fields.filter(filed => {
                return this.fieldList.indexOf(filed.value) !== -1
            })
            if (filedLast && filedLast.length > 0) {
                this.getParams();
                this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }
        }

        addOrUpdate(val) {

            this.customerVisible = true
            this.$nextTick(() => {
                this.$refs.customer.init(val, 0)
            })
        }

        deleteHandle(id) {
            let ids = id;
            if (!ids || ids.length == 0) return
            this.$confirm(`确定进行[撤销]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: '/bjba/equip/out/delete/' + id,
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if (data && data.code == 500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }

        getTypes() {
            this.$request.get('/bjba/equip/type/getAll').then(res => {

                this.types = res.data.data;
            })
        }

        getEquipConfigs() {
            this.$request.get('/bjba/equip/config/getAll').then(res => {

                this.equipConfigs = res.data.data;
            })
        }

        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser', {
                params: {
                    userid: this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
            })
        }

        getTypeName(typeid) {
            var typeName = ""
            if (typeid) {
                for (var i = 0; i < this.types.length; i++) {
                    if (typeid == this.types[i].id) {
                        typeName = this.types[i].name
                        break
                    }
                }
                return typeName
            }
            return typeName
        }
    }
</script>
<style lang="scss" scoped>
    .bcgl {
    }
</style>
